/**
 * Vanturis Passport Phase 8 — product context (host-aware routing).
 *
 * ONE Vanturis account, two products.  While passport.vanturis.com DNS
 * does not exist, Passport runs in path-mode under "/passport" on the
 * main host.  When the frontend is later served on a configured Passport
 * hostname (REACT_APP_PASSPORT_HOSTNAMES), the same route components
 * mount at the root instead — no rewrite required.
 */

const PASSPORT_HOSTNAMES = (process.env.REACT_APP_PASSPORT_HOSTNAMES || "")
  .split(",")
  .map((h) => h.trim().toLowerCase())
  .filter(Boolean);

export function isPassportHost() {
  if (typeof window === "undefined") return false;
  return PASSPORT_HOSTNAMES.includes(window.location.hostname.toLowerCase());
}

/** Base path of the Passport product on the current host. */
export function passportBase() {
  return isPassportHost() ? "" : "/passport";
}

/** Build a Passport-product-internal link. pp("/dashboard") → "/passport/dashboard" (path-mode) or "/dashboard" (host-mode). */
export function pp(path = "/") {
  const base = passportBase();
  const p = path.startsWith("/") ? path : `/${path}`;
  if (p === "/") return base || "/";
  return `${base}${p}`;
}

/** Marketplace product home from the current context. */
export function marketplaceHome() {
  if (!isPassportHost()) return "/";
  return process.env.REACT_APP_MARKETPLACE_URL || "https://vanturis.com";
}

/**
 * Validate a login returnTo target: internal same-origin paths only.
 * Rejects absolute URLs, protocol-relative, backslash and scheme tricks.
 */
export function safeReturnTo(raw, fallback) {
  const fb = fallback || pp("/dashboard");
  if (typeof raw !== "string" || !raw) return fb;
  const t = raw.trim();
  if (!t.startsWith("/") || t.startsWith("//")) return fb;
  if (t.includes("\\") || t.includes("://")) return fb;
  // eslint-disable-next-line no-control-regex
  if (/[\x00-\x1f]/.test(t)) return fb;
  return t;
}
